import TabChartOverview from '@/views/App/Dashboard/Admin/TabChartOverview.vue';
import TabInfo from '@/views/App/Dashboard/Admin/TabInfo.vue';
import TabPotentialUnits from '@/views/App/Dashboard/Admin/TabPotentialUnits.vue';

const routesDashboardAdmin= [
    {
        path: 'info',
        name: 'dashboardAdminInfo',
        component: TabInfo
    },
    {
        path: 'chart-overview',
        name: 'dashboardAdminChartOverview',
        component: TabChartOverview
    },
    {
        path: 'potential-units',
        name: 'dashboardAdminPotentialUnits',
        component: TabPotentialUnits
    },
  ];

export default routesDashboardAdmin;